const styles = theme => ({
  container: {
    background: theme.palette.primary.white,
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: 0,
    },
  },

  noContainerPadding: {
    padding: 0,
  },

  iconAndNameHolder: {
    marginRight: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: 0,
      borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
      padding: '16px !important',
    },
  },

  selectedHolder: {
    padding: 0,
    margin: '0 8px 0 0',
  },

  selected: {
    color: `${theme.palette.primary.adgmGreenDark} !important`,
  },
  selectedDisable: {
    color: `${theme.palette.secondary.disableLightGray} !important`,
  },

  icon: {
    width: '60px',
    height: '60px',
    [theme.breakpoints.down('sm')]: {
      width: '40px',
      height: '40px',
    },
  },

  nameHolder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },

  gridItemsHolder: {
    width: '100%',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      margin: '0! important',
    },
  },

  gridItem: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
      padding: '16px !important',
    },
  },
});
export default styles;
